import { RoomServiceLocationType } from '../../../../../services/exports/Constants';

export default {
  time_labels: {
    today: 'Oggi',
    asap: 'Prima possibile',
    scheduled: '{{date}}, {{time}}',
  },
  [RoomServiceLocationType.RoomService]: {
    details_label: 'Numero camera',
  },
  [RoomServiceLocationType.TableService]: {
    details_label: 'Numero tavolo',
  },
};
